var _style, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectuser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5C6E7D;stroke-width:1.5;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,22H9.2C4.2,22,2,19.8,2,14.8V9.2C2,4.2,4.2,2,9.2,2h5.6C19.8,2,22,4.2,22,9.2v5.6 C22,19.8,19.8,22,14.8,22z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 8.3,
    r: 2.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,19.5c0-4.1,2.8-7.5,6.2-7.5s6.2,3.3,6.2,7.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectuser);
export default __webpack_public_path__ + "static/media/selectuser.a74de546726f6f8c08c017761a6b2c2e.svg";
export { ForwardRef as ReactComponent };